export class Japa{
    id:any;
    japa_name:string;
    is_active:any;
}


// WEBPACK FOOTER //
// ./src/models/japa.ts